import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useProfile } from '../../hooks/useProfileApi';
import { useWorkspace } from '../../providers/useWorkspace';
import {
  usePublicProfileBuilder,
  type PublicProfileBuilderModel,
} from '../../hooks/usePublicProfileBuilder';

const PublicProfileBuilderContext = createContext<PublicProfileBuilderModel | null>(null);

export function PublicProfileBuilderProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { data: profile } = useProfile();
  const { activeWorkspace } = useWorkspace();

  const model = usePublicProfileBuilder({
    profile,
    user,
    workspaceType: activeWorkspace.type,
    workspace: activeWorkspace,
  });

  const value = useMemo(() => model, [model]);

  return (
    <PublicProfileBuilderContext.Provider value={value}>
      {children}
    </PublicProfileBuilderContext.Provider>
  );
}

export function usePublicProfileBuilderModel() {
  const ctx = useContext(PublicProfileBuilderContext);
  if (!ctx) {
    throw new Error(
      'PublicProfileBuilderProvider is missing for this profile builder screen.',
    );
  }
  return ctx;
}
